import React from "react";

export const OFFERING_VARIANTS_DISPLAY_STYLE = {
  DROPDOWN: "dropdown",
  OPTIONS: "options",
};

export const VARIATION_SETTINGS_FORM_KEYS = {
  DISPLAY_STYLE: "display_style",
  PRESELECT_DEFAULT: "preselect_default",
};

export const DISPLAY_STYLE_OPTIONS = [
  {
    label: "Show variations in a dropdown",
    value: OFFERING_VARIANTS_DISPLAY_STYLE.DROPDOWN,
  },
  {
    label: (
      <>
        Show variations as selectable cards{" "}
        <i>(all variations will be shown together)</i>
      </>
    ),
    value: OFFERING_VARIANTS_DISPLAY_STYLE.OPTIONS,
  },
];

export const colomnKeys = {
  title: {
    label: "Variation title",
    key: "title",
  },

  price: {
    label: "Price",
    domestic_price: "domestic_price",
    international_price: "international_price",
  },

  subscription_plan: {
    label: "Subscription plan",
    choice: "subscription_plan_choice",
    magnitude: "subscription_plan_magnitude",
  },

  type: {
    label: "Type",
    key: "variant_type",
  },

  kyc: {
    label: "KYC Verification",
  },

  action: {
    label: "Actions",
  },
};

export const OFFERING_VARIATIONS_LEARN_MORE_HREFS = {
  OFFERING_VARTIATION:
    "https://support.exlyapp.com/en/support/solutions/articles/84000392257-how-to-create-variations-of-your-offering-",
};
